import { differenceInYears } from 'date-fns';
import _ from 'lodash';

export const findDifferences = <T extends Object>(
  obj1: T,
  obj2: T
): Partial<T> => {
  const result: Partial<T> = {};

  _.forOwn(obj2, (value, key) => {
    if (value === null || value === undefined) {
      return;
    }

    const originalValue = obj1[key as keyof T];

    if (_.isObject(value) && _.isObject(originalValue)) {
      const nestedDifferences = findDifferences(originalValue, value);
      if (!_.isEmpty(nestedDifferences)) {
        result[key as keyof T] = nestedDifferences as any;
      }
    } else if (!_.isEqual(value, originalValue)) {
      result[key as keyof T] = value;
    }
  });

  return result;
};

export const minHeight = 110;
export const maxHeight = 250;

export const maxHeightInputValidation = (value: number) =>
  value >= 0 && value <= maxHeight;

export const minWeight = 5;
export const maxWeight = 500;

export const maxWeightInputValidation = (value: number) =>
  value >= 0 && value <= maxWeight;

export const ALLOW_PAYMENT = {
  admin: 'admin',
  all: 'all'
};

export const CAN_UPDATE_RESERVATIONS = {
  admin: 'admin',
  all: 'all'
};

export enum DESCRIPTION_MAX_LENGTH {
  short = 255,
  medium = 511,
  long = 1023
}

export const parentsVEP = ['ALUAR', 'Ninguno'];

export function getAgeRange(birthDate: Date): string {
  const currentDate = new Date();
  const age = differenceInYears(currentDate, birthDate);
  const cutoffDate = new Date(birthDate.getFullYear(), 5, 30); // 30 de junio del año de nacimiento

  // Ajuste de la edad para los alumnos que cumplen años después del 30 de junio
  // Si cumplen 5, 7 o 9 años después del 30 de junio, se les suma 1 a la edad
  // para determinar el grupo de edad al que pertenecen
  let adjustedAge = age;
  if (birthDate > cutoffDate) {
    if (age === 5 || age === 7 || age === 9) {
      adjustedAge = age + 1;
    }
  }

  if (adjustedAge >= 6 && adjustedAge <= 7) {
    return '6-7';
  } else if (adjustedAge >= 8 && adjustedAge <= 9) {
    return '8-9';
  } else if (adjustedAge >= 10) {
    return '+10';
  } else {
    return '4-5';
  }
}

export const ageGroups = {
  'group-6-7': '6-7',
  'group-8-9': '8-9',
  'group-10': '+10',
  'group-4-5': '4-5'
};

export const getGroup = (additionalData: any) => {
  const group = additionalData?.group as keyof typeof ageGroups;
  return ageGroups[group] || 'no';
};

export const VEPCodes = ['viento-en-popa', 'incubator-vp'];
